import React from 'react';

import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Button from '@mui/lab/LoadingButton';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { useMutation, useQueryClient } from 'react-query';
import { useForm, Controller } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { updateAccountRecordLimits } from 'api/accounts';

const loginSchema = yup.object().shape({
    limit: yup.number().required().min(0),
});

interface EditAccountRecordInterface extends DialogProps {
    accountRecordId: number;
}

const EditAccountRecordLimitsDialog: React.FC<EditAccountRecordInterface> = (props: EditAccountRecordInterface) => {
    const { accountRecordId } = props;

    const { playerId } = useParams();

    const queryClient = useQueryClient();

    const { control, handleSubmit, reset } = useForm({
        resolver: yupResolver(loginSchema),
        defaultValues: {
            limit: 0,
        },
    });

    const { mutate, isLoading } = useMutation(updateAccountRecordLimits, {
        onSuccess: () => {
            queryClient.invalidateQueries(['player-accounts', playerId]);
            props.onClose({}, 'backdropClick');
            reset();
        },
    });

    const onSubmit = handleSubmit(data => mutate({ ...data, accountRecordId }));

    return (
        // make dialog below semi-transparent

        <Dialog {...props} maxWidth="sm" fullWidth>
            <DialogTitle>Изменение лимитов на перевод записи #{accountRecordId}</DialogTitle>
            <DialogContent>
                <form className="flex flex-col space-y-4 pt-2" onSubmit={onSubmit} noValidate>
                    <Controller name="limit" control={control} render={({ field }) => <TextField label="Новый лимит" fullWidth required {...field} />} />
                    <div className="pt-4 text-right">
                        <Button type="submit" variant="contained" size="large" loading={isLoading}>
                            Изменить лимиты
                        </Button>
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default EditAccountRecordLimitsDialog;
